import api from '../../api';
import useHttpData from '../useHttpData';

/**
 * Whether the logged-in retailer has at least one virtual battery, read off one
 * `GET /batteries/devices` call.
 *
 * A 4xx is an answer — the session cannot see batteries — so it counts as none. Anything
 * else that fails (network, 5xx) is not an answer, so it counts as having batteries: the
 * few retailers who do have one should not lose their pages to a transient error, and a
 * retailer without one only sees the list page's own empty state.
 *
 * @param {boolean} enabled skip the call (and answer `false`) when nothing depends on it
 * @returns {boolean|null} `null` until the call settles
 */
const useHasVirtualBatteries = enabled => {
    const { data, isReady, error } = useHttpData(
        () =>
            enabled
                ? api
                      .get_vbatt_devices()
                      .then(res => (res?.data ?? []).length > 0)
                      .catch(err => {
                          const status = err?.response?.status;
                          if (status >= 400 && status < 500) {
                              return false;
                          }
                          throw err;
                      })
                : false,
        [enabled],
        null
    );
    if (!isReady) {
        return null;
    }
    return error ? true : data;
};

export default useHasVirtualBatteries;
